import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "@/components/common/SectionHeading";

export const FAQ = ({ id = "faq", eyebrow = "FAQs", title = "Frequently asked questions", subtitle, items = [] }) => {
  return (
    <section id={id} className="et-section bg-white">
      <div className="et-container">
        <SectionHeading eyebrow={eyebrow} title={title} subtitle={subtitle} />
        <div className="mt-10 max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
            {items.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="et-card border border-slate-200/70 px-5 data-[state=open]:shadow-[0_16px_44px_rgba(2,6,23,0.10)]">
                <AccordionTrigger className="text-left text-[15px] font-semibold text-slate-900 hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-slate-600 leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
